<div *ngIf="isDrawerOpen" class="vlp-backdrop" (click)="sidebarClose.emit()" aria-hidden="true"></div>

<div class="vlp-shell" [class.compact]="compact">
    <aside #sidebar *ngIf="!compact" class="vlp-sidebar" [class.open]="sidebarOpen" [class.collapsed]="collapsed && !isOverlaySidebar"
        [cdkTrapFocus]="isDrawerOpen" [attr.role]="isDrawerOpen ? 'dialog' : null"
        [attr.aria-modal]="isDrawerOpen ? 'true' : null" [attr.aria-label]="'layout.main-navigation' | transloco">
        <div class="sidebar-head">
            <dx-button class="brand-block" stylingMode="text" [hint]="'layout.toggle-menu' | transloco" (onClick)="brandClick.emit()">
                <div *dxTemplate="let data of 'content'">
                <span class="brand-mark">
                    <strong *ngIf="!logoUrl && !navLogoUrl" class="brand-text">{{ collapsed && !isOverlaySidebar ? brandTitle.slice(0, 2) : brandTitle }}</strong>
                    <img *ngIf="logoUrl && collapsed && !isOverlaySidebar; else expandedBrand" class="brand-logo brand-logo--icon" [src]="logoUrl" [alt]="brandTitle" />
                    <ng-template #expandedBrand>
                        <img *ngIf="navLogoUrl" class="brand-logo brand-logo--wordmark" [src]="navLogoUrl" [alt]="brandTitle" />
                    </ng-template>
                </span>
                </div>
            </dx-button>
            <!-- SL-548: nút thu gọn dùng MŨI TÊN theo yêu cầu QA (trước đây là chevron kép). -->
            <dx-button class="collapse-btn" *ngIf="!(collapsed && !isOverlaySidebar)" stylingMode="text" icon="chevronleft"
                [hint]="'layout.toggle-menu' | transloco" (onClick)="sidebarToggle.emit()" />
        </div>

        <div class="workspace-card" [class.workspace-card--selectable]="selectableWorkspace" *ngIf="!(collapsed && !isOverlaySidebar)">
            <span class="workspace-card__label">{{ "workspace-label" | transloco }}</span>
            <ng-content select="[shell-workspace]"></ng-content>
            <ng-container *ngIf="!selectableWorkspace">
                <strong [title]="workspaceName">{{ workspaceName }}</strong>
                <span class="workspace-card__meta">{{ workspaceMeta | transloco }}</span>
            </ng-container>
        </div>

        <div class="nav-filter" *ngIf="!(collapsed && !isOverlaySidebar)">
            <vlp-icon icon="heroicons_mini:magnifying-glass"></vlp-icon>
            <dx-text-box #menuSearch [value]="menuFilter" valueChangeEvent="input" [placeholder]="'nav-filter-placeholder' | transloco"
                (onValueChanged)="menuFilterChange.emit($event.value ?? '')" />
            
            <dx-button *ngIf="menuFilter" class="nav-filter-clear" stylingMode="text" icon="close"
                [hint]="'layout.clear' | transloco" (onClick)="menuFilterChange.emit(''); menuSearch.instance.focus()" />
        </div>

        <nav #sidebarNav class="vlp-nav" tabindex="-1" [attr.aria-label]="'layout.main-navigation' | transloco">
            <ng-container *ngFor="let group of groups; trackBy: trackNavigation">
                <dx-button class="section" stylingMode="text" [class.section-collapsed]="isGroupCollapsed(group.id!)"
                    [attr.aria-expanded]="!isGroupCollapsed(group.id!)"
                    [hint]="group.title || '' | transloco" (onClick)="groupToggle.emit(group.id!)">
                    <div *dxTemplate="let data of 'content'" class="section-content">
                    <span class="section__identity">
                        <span class="section__icon"><vlp-icon *ngIf="group.icon" [icon]="group.icon"></vlp-icon></span>
                        <span class="section__label">{{ group.title || "" | transloco }}</span>
                    </span>
                    <vlp-icon class="section-chevron" icon="heroicons_mini:chevron-down"></vlp-icon>
                    </div>
                </dx-button>
                <div *ngFor="let item of group.children; trackBy: trackNavigation" class="nav-item-row" [class.item-hidden]="isGroupCollapsed(group.id!)">
                    <a class="nav-item" [routerLink]="navigationLink(item.link)" [queryParams]="linkQueryParams"
                        [routerLinkActive]="group.id === '__favorites__' ? '' : 'active'" [routerLinkActiveOptions]="activeOptions(item)"
                        (click)="sidebarClose.emit()" [title]="item.title || '' | transloco" #rla="routerLinkActive" [attr.aria-current]="rla.isActive ? 'page' : null">
                        <span class="nav-item__icon"><vlp-icon *ngIf="item.icon" [icon]="item.icon"></vlp-icon></span>
                        <span class="nav-item__label">{{ item.title || "" | transloco }}</span>
                    </a>
                    <dx-button *ngIf="!(collapsed && !isOverlaySidebar)" class="nav-pin" [class.pinned]="isFavorite(item.link)"
                        stylingMode="text" icon="favorites" [hint]="(isFavorite(item.link) ? 'nav-unpin' : 'nav-pin') | transloco"
                        (onClick)="toggleFavorite(item.link)" />
                </div>
            </ng-container>
            <p *ngIf="menuFilter && groups.length === 0" class="nav-filter-empty">{{ "nav-filter-empty" | transloco }}</p>
        </nav>

        <div class="sidebar-footer">
            <span class="system-indicator" [class]="'system-indicator system-indicator--' + status"></span>
            <div *ngIf="!(collapsed && !isOverlaySidebar)">
                <strong>{{ (status === 'neutral' ? 'shell.verifiedSession' : 'backend-status.' + status) | transloco }}</strong>
                <small>{{ (status === 'neutral' ? 'shell.productWorkspace' : status === 'available' ? 'brand-slogan' : 'backend-status.retrying-detail') | transloco }}</small>
            </div>
        </div>
    </aside>

    <div #mainPanel class="vlp-main" tabindex="-1" [attr.inert]="isDrawerOpen ? '' : null">
        <header class="vlp-header">
            <strong *ngIf="compact" class="compact-brand">{{ brandTitle }}</strong>
            <dx-button #sidebarTrigger *ngIf="!compact" class="hamburger" stylingMode="text" icon="menu"
                [elementAttr]="{ 'aria-label': ('layout.menu' | transloco), 'aria-expanded': isDrawerOpen, 'aria-haspopup': 'dialog' }"
                [hint]="'layout.menu' | transloco" (onClick)="sidebarToggle.emit()" />
            <div class="breadcrumbs" [attr.aria-label]="'layout.breadcrumb' | transloco">
                <ng-container *ngFor="let c of crumbs; trackBy: trackBreadcrumb; let last = last">
                    <a *ngIf="!last" [routerLink]="c.url" [queryParams]="linkQueryParams" class="crumb-link">{{ c.label | transloco }}</a>
                    <span *ngIf="last" class="crumb-current" [attr.aria-current]="'page'">{{ c.label | transloco }}</span>
                    <vlp-icon *ngIf="!last" class="crumb-sep" icon="heroicons_mini:chevron-right"></vlp-icon>
                </ng-container>
            </div>
            <div class="header-context" *ngIf="accountName">
                <span class="header-context__dot"></span>
                <div><small>{{ "signed-in-as" | transloco }}</small><strong [title]="accountName">{{ accountName }}</strong></div>
            </div>
            <div class="header-actions">
                <ng-content select="[shell-actions]"></ng-content>
            </div>
        </header>
        <main class="vlp-content"><ng-content></ng-content></main>
    </div>
</div>
